import {
  temuDetail,
  temuBtgDetail,
  temuEdit,
  temuBtgEdit,
  getTemuProductAttribute,
  getTemuBrandList,
  getTemuParentSpec,
  uploadTemuCarouselVideo,
  editTemuCarouselVideo,
  getTemuGoodsAccessories,
  getTemuSizecharts,
  getTemuSizechartsClass,
  getTemuSizechartsMeta,
  getTemuSizechartsSettings,
  createTemuSizecharts,
  getTemuFreightTemp,
  getBtgSites,
  getBtgWarehouse,
  getBtgMultiSitePrice,
  getTemuModelCats,
  getTemuModelInfo,
  addTemuModelInfo,
} from '@/api/prod/center'
import store from '@/store'
import { cloneDeep, isEmpty, merge } from 'lodash';

export const getDefaultProductSkuWhExtAttr = () => {
  return {
    productSkuWeightReq: {
      weightValue: '', // 重量值，单位g
    },
    productSkuNetWeightReq:{ // 货品净重
      value:'',
    },
    productSkuSensitiveLimitReq: {
      // maxBatteryCapacityHp: '',  // 最大电池容量 (mWh)
      maxBatteryCapacity: '',  // 最大电池容量 (Wh)
      maxLiquidCapacity: '',  // 最大液体容量 (mL) 
      // maxLiquidCapacityHp: '',  // 最大液体容量 (uL) 
      maxKnifeLength: '',  // 	最大刀具长度 (mm)
      // maxKnifeLengthHp: '',  // 最大刀具长度 (μm)
      knifeTipAngle: {  // 刀尖角度
        degrees: ''     // 度
      }
    },
    productSkuVolumeReq: {
      volumeLen: '',  // 长，单位cm
      volumeWidth: '', // 宽，单位cm
      volumeHeight: '' // 高，单位cm
    },
    "productSkuBarCodeReqs": [  // 货品sku条码
      {
        "code": "",   // 条码
        "codeType": ''  // 条码类型 (1: EAN, 2: UPC, 3: ISBN)
      }
    ],
    "productSkuSensitiveAttrReq": {  // sku敏感属性
      "isSensitive": 0,   // 是否敏感属性，0：非敏感，1：敏感
      "sensitiveTypes": []  // 敏感类型
    }
  }
};
export const defaultProductSkuSuggestedPrice = {
  suggestedPriceStr: '',
  suggestedPriceCurrencyType: 'USD',
}
export const defaultProductSkuUsSuggestedPrice = {
  suggestedPriceStr: '',
  suggestedPriceCurrencyType: 'USD',
}
export const defaultSupplierPrice = {
  suggestedPriceStr: '',
  suggestedPriceCurrencyType: 'USD',
}
export const defaultProductSkuMultiPack = {
  "numberOfPieces": 1,
  "individuallyPacked": '',  //是否独立包装
  "skuClassification": 1,   // sku分类，1：单品，2：同款多件装，3：混合套装
  "pieceUnitCode": 1  // 单件单位，1：件，2：双，3：包
}
export const getDefaultProductSkuAccessories = (v) => {
  if (!v?.length) {
    return [{
      vid: '',
      value: '',
      num: '',
      unitCode: '',
      unitName: '',
    }]
  } else {
    return v
  }

}
export const getProductSkuWhExtAttr = (v) => {
  const originDefaultVal = getDefaultProductSkuWhExtAttr();
  const defaultVal = cloneDeep(originDefaultVal)
  const data = merge(defaultVal, v);

  // 保证关键字段不为 undefined/null
  if (!data.productSkuSensitiveLimitReq.knifeTipAngle) {
    data.productSkuSensitiveLimitReq.knifeTipAngle = { degrees: '' };
  }
  if (!Array.isArray(data.productSkuSensitiveAttrReq.sensitiveTypes)) {
    data.productSkuSensitiveAttrReq.sensitiveTypes = [];
  }
  if(!data.productSkuBarCodeReqs){
    data.productSkuBarCodeReqs = originDefaultVal.productSkuBarCodeReqs
  }
  return data
}
// 过滤上传失败或为空的图片
export function _filterInvalidImg(imgsArr) {
  return imgsArr.filter(img => {
    if (!img) {
      return false
    } else if (typeof img === 'object') {
      return false
    } else {
      return true
    }
  })
}
const getProductSkuAccessoriesData = (list) => {
  const filterList = list.filter(item => item.vid && item.num && item.unitCode)
  return JSON.stringify(filterList)
}

// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsItem(r, isRequest) {
  if (r.skuList && r.skuList.length > 0) {
    r.skuList = r.skuList.map(item => {
      const skuSpecifications = isRequest ? JSON.stringify(item.skuSpecifications || []) : JSON.parse(item.skuSpecifications || '[]')
      const productSkuAccessories = isRequest ? getProductSkuAccessoriesData(item.productSkuAccessories || []) : getDefaultProductSkuAccessories(JSON.parse(item.productSkuAccessories || '[]')) // 货品SKU包装清单
      const productSkuWhExtAttr = isRequest ? JSON.stringify(item.productSkuWhExtAttr || {}) : getProductSkuWhExtAttr(JSON.parse(item.productSkuWhExtAttr || '{}')) // 货品sku扩展属性
      const productSkuSuggestedPrice = isRequest ? JSON.stringify(item.productSkuSuggestedPrice || {}) : merge(cloneDeep(defaultProductSkuSuggestedPrice), JSON.parse(item.productSkuSuggestedPrice || '{}')) // sku 建议售价
      const productSkuUsSuggestedPrice = isRequest ? JSON.stringify(item.productSkuUsSuggestedPrice || {}) : merge(cloneDeep(defaultProductSkuUsSuggestedPrice), JSON.parse(item.productSkuUsSuggestedPrice || '{}')) // sku 制造商建议售价
      const productSkuMultiPack = isRequest ? JSON.stringify(item.productSkuMultiPack || {}) : merge(cloneDeep(defaultProductSkuMultiPack), JSON.parse(item.productSkuMultiPack || '{}')) // sku分类
      const _skuid = isRequest ? "" : skuSpecifications.map(sp => sp.valueKey).filter(Boolean).join('-')
      const valueKeys = isRequest ? null : skuSpecifications.filter(sp => sp.valueKey).map(sp => sp.valueKey)
      return {
        ...item,
        productSkuAccessories,
        productSkuWhExtAttr,
        productSkuSuggestedPrice,
        productSkuUsSuggestedPrice,
        productSkuMultiPack,
        valueKeys,
        _skuid,
        skuSpecifications
      }
    })
  }

  return isRequest ? {
    ...r,
    specifications: JSON.stringify(r.specifications ? r.specifications : []),
    shopBrandConf: JSON.stringify(r.shopBrandConf ? r.shopBrandConf : []),
    goodsLayerDecoration: JSON.stringify(r.goodsLayerDecoration ? r.goodsLayerDecoration : []),
    productProperty: JSON.stringify(r.productProperty ? r.productProperty : []),
    carouselImage: JSON.stringify(r.carouselImage ? r.carouselImage : []),
    productGuideFile: JSON.stringify(r.productGuideFile ? r.productGuideFile : []),
    sizeTemplate: JSON.stringify(r.sizeTemplate ? r.sizeTemplate : {}),
    // productOuterPackageInfo: JSON.stringify(r.productOuterPackageInfo ? r.productOuterPackageInfo : {}),
    // productWhExtAttr: JSON.stringify(r.productWhExtAttr ? r.productWhExtAttr : {}),
    customizedTechnology: JSON.stringify(r.customizedTechnology ? r.customizedTechnology : {}),
    categoryIds: r.categoryIds ? r.categoryIds.join(',') : '',
    // shopSizeTemplateVo: JSON.stringify(r.shopSizeTemplateVo ? r.shopSizeTemplateVo : []),
  } : {
    ...r,
    specifications: r.specifications ? JSON.parse(r.specifications) : [],
    shopBrandConf: r.shopBrandConf ? JSON.parse(r.shopBrandConf) : [],
    goodsLayerDecoration: r.goodsLayerDecoration ? JSON.parse(r.goodsLayerDecoration) : [],
    productProperty: r.productProperty ? JSON.parse(r.productProperty) : [],
    carouselImage: r.carouselImage ? JSON.parse(r.carouselImage) : [],
    productGuideFile: r.productGuideFile ? JSON.parse(r.productGuideFile) : [],
    sizeTemplate: r.sizeTemplate ? JSON.parse(r.sizeTemplate) : {},
    // productOuterPackageInfo: r.productOuterPackageInfo ? JSON.parse(r.productOuterPackageInfo) : {},
    // productWhExtAttr: r.productWhExtAttr ? JSON.parse(r.productWhExtAttr) : {},
    customizedTechnology: r.customizedTechnology ? JSON.parse(r.customizedTechnology) : {},
    categoryIds: r.categoryIds ? r.categoryIds.split(',') : [],
    // shopSizeTemplateVo: r.shopSizeTemplateVo ? JSON.parse(r.shopSizeTemplateVo) : [],
  }
}
// 半托管-格式化每个商品数据
export function _formatGoodsItemBtg(r, isRequest) {
  if (r.skuList && r.skuList.length > 0) {
    r.skuList = r.skuList.map(item => {
      const skuSpecifications = isRequest ? JSON.stringify(item.skuSpecifications || []) : JSON.parse(item.skuSpecifications || '[]')
      const productSkuAccessories = isRequest ? getProductSkuAccessoriesData(item.productSkuAccessories || []) : getDefaultProductSkuAccessories(JSON.parse(item.productSkuAccessories || '[]')) // 货品SKU包装清单
      const productSkuWhExtAttr = isRequest ? JSON.stringify(item.productSkuWhExtAttr || {}) : getProductSkuWhExtAttr(JSON.parse(item.productSkuWhExtAttr || '{}')) // 货品sku扩展属性
      const productSkuSuggestedPrice = isRequest ? JSON.stringify(item.productSkuSuggestedPrice || {}) : merge(cloneDeep(defaultProductSkuSuggestedPrice), JSON.parse(item.productSkuSuggestedPrice || '{}')) // sku 建议售价
      const productSkuUsSuggestedPrice = isRequest ? JSON.stringify(item.productSkuUsSuggestedPrice || {}) : merge(cloneDeep(defaultProductSkuUsSuggestedPrice), JSON.parse(item.productSkuUsSuggestedPrice || '{}')) // sku 制造商建议售价
      const productSkuMultiPack = isRequest ? JSON.stringify(item.productSkuMultiPack || {}) : merge(cloneDeep(defaultProductSkuMultiPack), JSON.parse(item.productSkuMultiPack || '{}')) // sku分类
      const _skuid = isRequest ? "" : skuSpecifications.map(sp => sp.valueKey).filter(Boolean).join('-')
      const valueKeys = isRequest ? null : skuSpecifications.filter(sp => sp.valueKey).map(sp => sp.valueKey)
      return {
        ...item,
        productSkuAccessories,
        productSkuWhExtAttr,
        productSkuSuggestedPrice,
        productSkuUsSuggestedPrice,
        productSkuMultiPack,
        valueKeys,
        _skuid,
        skuSpecifications
      }
    })
  }

  return isRequest ? {
    ...r,
    specifications: JSON.stringify(r.specifications ? r.specifications : []),
    shopBrandConf: JSON.stringify(r.shopBrandConf ? r.shopBrandConf : []),
    goodsLayerDecoration: JSON.stringify(r.goodsLayerDecoration ? r.goodsLayerDecoration : []),
    productProperty: JSON.stringify(r.productProperty ? r.productProperty : []),
    carouselImage: JSON.stringify(r.carouselImage ? r.carouselImage : []),
    productGuideFile: JSON.stringify(r.productGuideFile ? r.productGuideFile : []),
    sizeTemplate: JSON.stringify(r.sizeTemplate ? r.sizeTemplate : {}),
    // productOuterPackageInfo: JSON.stringify(r.productOuterPackageInfo ? r.productOuterPackageInfo : {}),
    // productWhExtAttr: JSON.stringify(r.productWhExtAttr ? r.productWhExtAttr : {}),
    customizedTechnology: JSON.stringify(r.customizedTechnology ? r.customizedTechnology : {}),
    categoryIds: r.categoryIds ? r.categoryIds.join(',') : '',
    operateSites:JSON.stringify(r.operateSites ? r.operateSites : []),
    siteWarehouseStock:JSON.stringify(r.siteWarehouseStock ? r.siteWarehouseStock : []),
    multiSitePrices:JSON.stringify(r.multiSitePrices ? r.multiSitePrices : []),
  } : {
    ...r,
    specifications: r.specifications ? JSON.parse(r.specifications) : [],
    shopBrandConf: r.shopBrandConf ? JSON.parse(r.shopBrandConf) : [],
    goodsLayerDecoration: r.goodsLayerDecoration ? JSON.parse(r.goodsLayerDecoration) : [],
    productProperty: r.productProperty ? JSON.parse(r.productProperty) : [],
    carouselImage: r.carouselImage ? JSON.parse(r.carouselImage) : [],
    productGuideFile: r.productGuideFile ? JSON.parse(r.productGuideFile) : [],
    sizeTemplate: r.sizeTemplate ? JSON.parse(r.sizeTemplate) : {},
    // productOuterPackageInfo: r.productOuterPackageInfo ? JSON.parse(r.productOuterPackageInfo) : {},
    // productWhExtAttr: r.productWhExtAttr ? JSON.parse(r.productWhExtAttr) : {},
    customizedTechnology: r.customizedTechnology ? JSON.parse(r.customizedTechnology) : {},
    categoryIds: r.categoryIds ? r.categoryIds.split(',') : [],
    operateSites:r.operateSites ? JSON.parse(r.operateSites) : [],
    siteWarehouseStock:r.siteWarehouseStock ? JSON.parse(r.siteWarehouseStock) : [],
    multiSitePrices:r.multiSitePrices ? JSON.parse(r.multiSitePrices) : [],
  }
}

// 编辑详情
export function editTemuInfo(data) {
  return temuEdit(_formatGoodsItem(data, true)).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}
// 编辑详情-半托管
export function editTemuBtgInfo(data) {
  return temuBtgEdit(_formatGoodsItemBtg(data, true)).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}

// 获取详情资料
export function getTemuDetail(params) {
  return temuDetail(params).then(res => {
    if (res.result === 1) {
      return _formatGoodsItem(res.data || {})
    } else {
      return false
    }
  })
}
// 获取详情资料-半托管
export function getTemuBtgDetail(params) {
  return temuBtgDetail(params).then(res => {
    if (res.result === 1) {
      return _formatGoodsItemBtg(res.data || {})
    } else {
      return false
    }
  })
}

// 获取类目属性
export function getCategoryProperties(param) {
  return getTemuProductAttribute(param).then(res => {
    if (res.result === 1) {
      return res.data || {};
    } else {
      return {};
    }
  })
}

export function getBrandList(data) {
  return getTemuBrandList(data).then(res => {
    if (res.result === 1) {
      return res.data || []
    } else {
      return []
    }
  })
}


export function getParentSpec(data) {
  return getTemuParentSpec(data).then(res => {
    if (res.result === 1) {
      return res.data || []
    } else {
      return []
    }
  })
}

// 上传轮播视频到店铺
export function uploadCarouselVideo(data = {}) {
  return uploadTemuCarouselVideo(data).then(res => {
    if (res.result === 1) {
      return true;
    }
  })
}
// 编辑轮播视频
export function editCarouselVideo(data = {}) {
  return editTemuCarouselVideo(data).then(res => {
    if (res.result === 1) {
      return res.data || null;
    }
  })
}

// 查询货品包装清单类型
export function getGoodsAccessories(data = {}) {
  return getTemuGoodsAccessories(data).then(res => {
    if (res.result === 1) {
      return res.data || [];
    }
  })
}

export function getSizecharts(data = {}) {
  return getTemuSizecharts(data).then(res => {
    if (res.result === 1) {
      return res.data || [];
    }
  })
}
export function getSizechartsClass(data = {}) {
  return getTemuSizechartsClass(data).then(res => {
    if (res.result === 1) {
      return res.data || [];
    }
  })
}
export function getSizechartsMeta(data = {}) {
  return getTemuSizechartsMeta(data).then(res => {
    if (res.result === 1) {
      return res.data || false;
    } else {
      return false
    }
  })
}
export function getSizechartsSettings(data = {}) {
  return getTemuSizechartsSettings(data).then(res => {
    if (res.result === 1) {
      return res.data || [];
    }
  })
}
export function createSizecharts(data = {}) {
  return createTemuSizecharts(data).then(res => {
    if (res.result === 1) {
      return true;
    }
  })
}
// 查询运费模版列表（全托管 / 半托管通用）
export function getFreightTemp(data = {}) {
  return getTemuFreightTemp(data).then(res => {
    if (res.result === 1) {
      return res.data;
    }
  })
}
// 半托管 - 查询经营站点列表（仅已开站，支持按站点名称 / 站点ID 搜索）
export function getSites(data = {}) {
  return getBtgSites(data).then(res => {
    if (res.result === 1) {
      return res.data;
    }
  })
}
// 半托管 - 查询发货仓列表
export function getWarehouse(data = {}) {
  return getBtgWarehouse(data).then(res => {
    if (res.result === 1) {
      return res.data;
    }
  })
}
// 半托管 - 多站点申报价查询
export function getMultiSitePrice(data = {}) {
  return getBtgMultiSitePrice(data).then(res => {
    if (res.result === 1) {
      return res.data;
    }
  })
}
// 查询是否支持模特
export function getModelCats(data = {}) {
  return getTemuModelCats(data).then(res => {
    if (res.result === 1) {
      return res.data;
    }
  })
}
// 查询模特数据
export function getModelInfo(data = {}) {
  return getTemuModelInfo(data).then(res => {
    if (res.result === 1) {
      return res.data;
    }
  })
}
// 新增模特
export function addModelInfo(data = {}) {
  return addTemuModelInfo(data).then(res => {
    if (res.result === 1) {
      return res.data;
    }
  })
}



